import React, { useReducer } from 'react'
import DataTable from './DataTable'
import _ from 'lodash'
import * as R from 'ramda'
import ErrorFetchingLoading from 'app/main/messages/notificationTimeline/ErrorFetchingLoading'
import { Checkbox } from '@material-ui/core'
import clsx from 'clsx'

const checkIdDuplicate = (data, checkIds) => {
  const filterData = data.filter((item) => {
    return R.includes(item.id, checkIds)
  })
  return filterData.length === checkIds.length
}

const handleCheckAll = ({ data, checkIds, page, pageSize }) => {
  if (R.isNil(checkIds)) {
    return { isCheckAll: false, indeterminate: false }
  }
  if (
    R.length(data) <= pageSize &&
    R.length(checkIds) === R.length(data) &&
    page === 1 &&
    checkIdDuplicate(data, checkIds)
  ) {
    return { isCheckAll: true, indeterminate: false }
  }

  const lastPage = Math.floor(data.length / pageSize) + 1
  const dataLastPage = data.length - pageSize * (lastPage - 1)

  const dataLengthOfPage = data.filter((item, index) => {
    const lastIndexOfPage = page * pageSize - 1
    const firstIndexOfPage = page * pageSize - pageSize

    if (index < firstIndexOfPage || index > lastIndexOfPage) {
      return false
    }

    return R.isEmpty(checkIds) ? false : R.includes(item.id, checkIds)
  })
  const isCheckAll =
    dataLengthOfPage.length > 0 &&
    (dataLengthOfPage.length === pageSize ||
      (dataLengthOfPage.length === dataLastPage && page === lastPage))
  return {
    isCheckAll,
    indeterminate: !isCheckAll && dataLengthOfPage.length > 0,
  }
}

const initialState = {
  checkedItems: [],
  searchText: '',
  subscriberList: [],
  pageSize: 10,
  page: 1,
  isCheckAll: false,
  indeterminate: false,
}

const ActionTypes = {
  HANDEL_CHECK_ALL: 'HANDEL_CHECK_ALL',
  SELECTED_ITEM: 'SELECTED_ITEM',
  ON_PAGE_CHANGE: 'ON_PAGE_CHANGE',
  ON_PAGE_SIZE_CHANGE: 'ON_PAGE_SIZE_CHANGE',
  SET_DEFAULT: 'SET_DEFAULT',
  SEARCH_TEXT: 'SEARCH_TEXT',
  SUBMIT_DATA: 'SUBMIT_DATA',
  SET_INITAIL_DATA: 'SET_INITAIL_DATA',
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.HANDEL_CHECK_ALL:
      return {
        ...state,
        checkedItems: action.payload,
        ...handleCheckAll({
          data: state.subscriberList,
          checkIds: action.payload,
          page: state.page,
          pageSize: state.pageSize,
        }),
      }
    case ActionTypes.SELECTED_ITEM:
      return {
        ...state,
        checkedItems: action.payload,
        ...handleCheckAll({
          data: state.subscriberList,
          checkIds: action.payload,
          page: state.page,
          pageSize: state.pageSize,
        }),
      }
    case ActionTypes.ON_PAGE_CHANGE:
      return {
        ...state,
        page: action.payload,
        ...handleCheckAll({
          data: state.subscriberList,
          checkIds: state.checkedItems,
          page: action.payload,
          pageSize: state.pageSize,
        }),
      }
    case ActionTypes.ON_PAGE_SIZE_CHANGE:
      return {
        ...state,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        ...handleCheckAll({
          data: state.subscriberList,
          checkIds: state.checkedItems,
          page: action.payload.page,
          pageSize: action.payload.pageSize,
        }),
      }
    case ActionTypes.SET_DEFAULT:
      return {
        ...state,
        subscriberList: action.payload.subscriberList,
        checkedItems: action.payload.checkIds,
        searchText: '',
        pageSize: 10,
        page: 1,
        ...handleCheckAll({
          data: action.payload.subscriberList,
          checkIds: action.payload.checkIds,
          page: 1,
          pageSize: 10,
        }),
      }
    case ActionTypes.SUBMIT_DATA:
      return {
        ...state,
        subscriberList: state.subscriberList,
        checkedItems: action.payload,
        searchText: '',
        pageSize: 10,
        page: 1,
        ...handleCheckAll({
          data: state.subscriberList,
          checkIds: action.payload,
          page: 1,
          pageSize: 10,
        }),
      }
    case ActionTypes.SEARCH_TEXT:
      return {
        ...state,
        subscriberList: action.payload.subscriberList,
        searchText: action.payload.text,
        page: 1,
        pageSize:
          action.payload.text && action.payload.subscriberList.length <= 10
            ? action.payload.subscriberList.length
            : 10,
        ...handleCheckAll({
          data: action.payload.subscriberList,
          checkIds: state.checkedItems,
          page: 1,
          pageSize:
            action.payload.text && action.payload.subscriberList.length <= 10
              ? action.payload.subscriberList.length
              : 10,
        }),
      }
    case ActionTypes.SET_INITAIL_DATA:
      return action.payload
    default:
      return state
  }
}

export const useTableNotServerSide = () => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const setInitailDate = ({ checkedItems, subscriberList }) => {
    dispatch({
      type: 'SET_INITAIL_DATA',
      payload: {
        checkedItems: checkedItems || [],
        searchText: '',
        subscriberList,
        pageSize: 10,
        page: 1,
        ...handleCheckAll({
          data: subscriberList,
          checkIds: checkedItems,
          page: 1,
          pageSize: 10,
        }),
      },
    })
  }

  const toggleSelectAll = (checked) => {
    const lastIndexOfPage = state.page * state.pageSize - 1
    const firstIndexOfPage = state.page * state.pageSize - state.pageSize
    const listIds = state.subscriberList
      .filter((item, index) => {
        return index >= firstIndexOfPage && index <= lastIndexOfPage
      })
      .map((item) => item.id)

    const checkedItems = [
      ...new Set(
        checked
          ? [...state.checkedItems, ...listIds]
          : state.checkedItems.filter((item) => {
              return !R.includes(item, listIds)
            }),
      ),
    ]

    dispatch({ type: ActionTypes.HANDEL_CHECK_ALL, payload: checkedItems })
  }

  const toggleSelect = (id) => {
    const checkedItems = state.checkedItems.includes(id)
      ? state.checkedItems.filter((itemId) => itemId !== id)
      : [...state.checkedItems, id]

    dispatch({
      type: ActionTypes.SELECTED_ITEM,
      payload: checkedItems,
    })
  }

  const checkBoxColumn = {
    accessor: '',
    sortable: false,
    width: 96,
    Header: () => (
      <div>
        <Checkbox
          color="secondary"
          onClick={(event) => {
            event.stopPropagation()
          }}
          onChange={R.compose(toggleSelectAll, R.path(['target', 'checked']))}
          checked={state.isCheckAll}
          indeterminate={state.indeterminate}
        />
      </div>
    ),
    Cell: (row) => {
      return (
        <Checkbox
          onClick={(event) => {
            event.stopPropagation()
          }}
          color="secondary"
          checked={state.checkedItems.includes(row.value.id)}
          onChange={() => R.compose(toggleSelect, R.path(['value', 'id']))(row)}
        />
      )
    },
    className: clsx('sticky fixBackground'),
    headerClassName: clsx('sticky'),
  }

  const onPageChange = (page) => {
    dispatch({ type: 'ON_PAGE_CHANGE', payload: page + 1 })
  }

  const onPageSizeChange = (pageSize, pageIndex) => {
    dispatch({
      type: 'ON_PAGE_SIZE_CHANGE',
      payload: { pageSize, page: pageIndex + 1 },
    })
  }

  const setToDfaultData = ({ checkIds, subscriberList }) => {
    dispatch({
      type: 'SET_DEFAULT',
      payload: { checkIds, subscriberList },
    })
  }

  const onSearchData = ({ text, subscriberList }) => {
    if (!R.isEmpty(text)) {
      let searchText = text.toLowerCase()
      const subscriberListSearch = subscriberList.filter((subscriber) => {
        let fullName = subscriber.firstName + subscriber.lastName
        let fullNameWithSpace = subscriber.firstName + ' ' + subscriber.lastName
        fullName = fullName ? fullName.toLowerCase() : ''
        fullNameWithSpace = fullNameWithSpace
          ? fullNameWithSpace.toLowerCase()
          : ''
        const isPassedSearch =
          fullName.includes(searchText) ||
          fullNameWithSpace.includes(searchText)
        return isPassedSearch
      })
      dispatch({
        type: 'SEARCH_TEXT',
        payload: { subscriberList: subscriberListSearch, text },
      })
    } else {
      dispatch({
        type: 'SEARCH_TEXT',
        payload: { subscriberList, text: '' },
      })
    }
  }

  const submitData = (checkIds) => {
    dispatch({ type: 'SUBMIT_DATA', payload: checkIds })
  }

  return {
    checkBoxColumn,
    state,
    onPageChange,
    onPageSizeChange,
    setToDfaultData,
    onSearchData,
    submitData,
    setInitailDate,
  }
}

const FetchTable = ({
  onFetchData,
  refetchData,
  onClickRow,
  className,
  isClickRowDisable,
  error,
  ...rest
}) => {
  if (error) {
    return (
      <ErrorFetchingLoading error={error} isShow onLoadSuccess={refetchData} />
    )
  }

  return (
    <DataTable
      {...rest}
      className={className}
      getTrProps={
        onClickRow
          ? (state, rowInfo, column) => {
              return {
                className: isClickRowDisable ? '' : 'cursor-pointer',
                onClick: (e, handleOriginal) => {
                  if (isClickRowDisable) {
                    return
                  }
                  if (rowInfo) {
                    onClickRow(rowInfo.original)
                  }
                },
              }
            }
          : undefined
      }
      onFetchData={R.unless(R.isNil, (func) => _.debounce(func, 500))(
        onFetchData,
      )}
    />
  )
}

export default React.memo(FetchTable)
